import { render } from "./CookieBanner.vue?vue&type=template&id=84bb6afa&ts=true"
import script from "./CookieBanner.vue?vue&type=script&lang=ts"
export * from "./CookieBanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__